import template from './fee-client.jade';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.bargainFeeClient', [])
    .directive('cianAfPriceAndDealTermsFeeClient', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['adStateService', 'deviceService', function(adStateService, deviceService) {
            this.isMobile = deviceService.isMobile;
            if (!this.ad.bargainTerms) {
                this.ad.bargainTerms = {};
            }

            const isSaved = this.ad.id ? true : false;

            if (!this.ad.bargainTerms.clientFee) {
                this.ad.bargainTerms.clientFee = null;
                this.noClientFee = isSaved;
            }

            this.noClientFeeChanged = () => {
                if (this.noClientFee)   {
                    this.ad.bargainTerms.clientFee = null;
                    this.form['bargainTerms.clientFee'].$setUntouched();
                }
            };

            this.validation = validation(this.form, 'bargainTerms.clientFee', {
                parse: 'Введите число',
                required: 'Укажите процент от прямого клиента',
                min: 'Значение не может быть отрицательным',
                max: 'Процент должен быть меньше или равен 100%',
            });

        }],
        controllerAs: 'feeClient',
        template,
    }))
    .name;
